import { GeneralRoutes } from './customerSubRoutes/GeneralRoutes'
import { IRoute } from '../models/routes/IRoute'
import { ProfileRoutes } from './customerSubRoutes/profileRoutes'

const customerRoutesConfig: IRoute[] = [
  ...GeneralRoutes,
  ...ProfileRoutes,
]

export default customerRoutesConfig;